module.exports = __webpack_public_path__ + "public/img/yezf.f507a232.png";